import actions from './actions'

const defaultOrganization = {
    boss_id: 0,
    deputy_id: [],
    member_ids: [],
    name: '',
    type: null,
    oid: -1,
    ext_data: {
        avatarOrgani: '',
        description: '',
    },
}

const initState = {
    organizations: [],

    currentOrganization: defaultOrganization,

    isLoading: false,
    loadType: actions.loadType.GET_NOT_DELETED,

    showModal: false,
    title: '',
    titleButtonModal: '',
    component: null,
    organiEditing: null,

    listAllUser: [],

    showModalUsers: false,
    titleModalListUser: '',
    listUser: [],

    //for Search User
    listUserSearched: [],
    value: [],
    searching: false,

    avatarOrganization: '',
    //
    currentListOrg: null,
    bossInfo: {},

    avatar_file: '',
    showModalListUser: false,

    listBoss: [],
    listDeputy: [],
    listMember: [],
    listUserInOrgani: [],
    showModalInfo: false,

    listOrgUpdate: [],
    roles: [],
    actionsInRole: [],

    roleOfUserInOrgani: {
        createOrgani: false,
        editOrgani: false,
        viewOrgani: false,
        deleteOrgani: false,
    },
    orgGetById: {},
}

const organizationReducer = (state = initState, action) => {
    switch (action.type) {
        case actions.type.GET_ORG_BY_ID_DONE:
            return {
                ...state,
                ...{
                    orgGetById: action.payload.data,
                },
            }
        case actions.type.LOAD_LIST_ORGANIZATIONS:
            return {
                ...state,
                ...{
                    isLoading: true,
                    loadType: action.payload.loadType,
                },
            }

        case actions.type.LOAD_LIST_ORGANIZATIONS_SUCCESS:
            return {
                ...state,
                ...{
                    isLoading: false,
                    organizations: action.payload.organizations,
                },
            }
        case actions.type.PRE_ADD_ORGANIZATION:
            console.log('PREa: ', defaultOrganization)
            return {
                ...state,
                ...{
                    currentOrganization: defaultOrganization,
                    avatar_file: null,
                },
            }

        case actions.type.ADD_ORGANIZATIONS_SUCCESS: {
            const { organization } = action.payload
            //console.log('data', organization)

            // toastSuccess('Thêm mới Don vi thành công');
            return {
                ...state,
                organizations: [organization].concat(state.organizations),
            }
        }

        case actions.type.UPDATE_CURRENT_ORGANIZATION: {
            //console.log("action.payload: ", action.payload)
            return {
                ...state,
                ...{
                    currentOrganization: {
                        ...state.currentOrganization,
                        ...action.payload.object,
                    },
                },
            }
        }

        case actions.type.UPDATE_ORGANIZATION: {
            return {
                ...state,
                ...{
                    isLoading: true,
                },
            }
        }

        case actions.type.REMOVE_ORGANIZATION: {
            return {
                ...state,
                ...{
                    isLoading: true,
                },
            }
        }
        case actions.type.REMOVE_ORGANIZATION_SUCCESS: {
            const { oid } = action.payload
            return {
                ...state,
                ...{
                    organizations: state.organizations.filter(
                        item => item.oid !== oid
                    ),
                },
            }
        }

        case actions.type.CREATE_ORGANIZATION:
            return {
                ...state,
                ...{
                    isLoading: true,
                },
            }

        case actions.type.SHOW_MODAL_INFO_ORGANIZATION: {
            return {
                ...state,
                showModalInfo: true,
            }
        }
        case actions.type.HIDE_MODAL_INFO_ORGANIZATIONS: {
            return {
                ...state,
                showModalInfo: false,
            }
        }
        //for ModalOrganization
        case actions.type.SHOW_MODAL_ORGANIZATIONS: {
            return {
                ...state,
                showModal: true,
            }
        }
        case actions.type.HIDE_MODAL_ORGANIZATIONS: {
            return {
                ...state,
                showModal: false,
                title: '',
                titleButtonModal: '',
                component: null,
            }
        }
        case actions.type.CHANGE_MODAL_TITLE_ORGANIZATIONS: {
            const { title, titleButtonModal } = action.payload
            return {
                ...state,
                title,
                titleButtonModal,
            }
        }
        case actions.type.CHANGE_MODAL_COMPONENT_ORGANIZATIONS: {
            const { component } = action.payload
            return {
                ...state,
                component,
            }
        }
        case actions.type.SHOW_MODAL_USERS: {
            return {
                ...state,
                showModalUsers: true,
            }
        }
        case actions.type.HIDE_MODAL_USERS: {
            return {
                ...state,
                showModalUsers: false,
            }
        }
        case actions.type.CHANGE_MODAL_TITLE_USERS: {
            const { title } = action.payload
            return {
                ...state,
                titleModalListUser: title,
            }
        }

        case actions.type.GET_BOSS_SUCCESS: {
            const { data } = action.payload
            //console.log("rederu: ", data)
            return {
                ...state,
                listBoss: data,
            }
        }

        case actions.type.GET_LIST_DEPUTY_SUCCESS: {
            const { data } = action.payload
            //console.log("rederu: ", data)
            return {
                ...state,
                listDeputy: data,
            }
        }

        case actions.type.GET_LIST_MEMBER_SUCCESS: {
            const { data } = action.payload
            //console.log("rederu: ", data)
            return {
                ...state,
                listMember: data,
            }
        }

        case actions.type.GET_LIST_USER_IN_ORGANI_SUCCESS: {
            const { data } = action.payload
            return {
                ...state,
                listUserInOrgani: data,
            }
        }

        case actions.type.SEARCH_MEMBER_SUCCESS:
            const { data } = action.payload
            return {
                ...state,
                ...{
                    searching: false,
                    listUserSearched: data,
                },
            }

        case actions.type.AVATAR_ORGANIZATION:
            const { url } = action.payload
            return {
                ...state,
                avatarOrganization: url,
            }

        case actions.type.GET_LIST_ORG_QUERY_BY_ID_DONE:
            let lstIndex = []
            action.payload.data.map(vl => {
                lstIndex.push(vl.oid)
            })
            const dataOrg = action.payload.data
            let dataFinalOrg = []
            const output = lstIndex.filter((element, indexOfElement) => {
                if (indexOfElement === lstIndex.indexOf(element)) {
                    dataFinalOrg.push(dataOrg[indexOfElement])
                }
            })
            console.log('output', output)

            return {
                ...state,
                ...{
                    currentListOrg: dataFinalOrg,
                    listOrgUpdate: [],
                },
            }

        case actions.type.GET_BOSS_INFO_SUCCESS: {
            const { data } = action.payload
            return {
                ...state,
                bossInfo: data,
            }
        }
        case actions.type.UPDATE_LIST_ORG_QUERY:
            return {
                ...state,
                ...{
                    listOrgUpdate: state.listOrgUpdate.concat(
                        action.payload.data
                    ),
                },
            }
        case actions.type.GET_LIST_ROLES_SUCCESS:
            return {
                ...state,
                ...{
                    roles: action.payload.roles,
                },
            }
        case actions.type.GET_LIST_ACTION_BY_ID_SUCCESS:
            return {
                ...state,
                ...{
                    actionsInRole: action.payload.data,
                },
            }
        case actions.type.UPDATE_ROLE_OF_USER_IN_ORGANI:
            return {
                ...state,
                roleOfUserInOrgani: action.payload.object,
            }
        default:
            return state
    }
}

export default organizationReducer
